import { render } from "./auth.vue?vue&type=template&id=b4a140ce&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"

import "./auth.vue?vue&type=style&index=0&id=b4a140ce&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-b4a140ce"

export default script